import { render, staticRenderFns } from "./AssignmentModal.vue?vue&type=template&id=276fae3c&"
import script from "./AssignmentModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports